import { ACCEPT, PROVIDE } from "./events";
import type { CarouselPattern } from "./carousel";
import { patternName } from "./pattern";
import { buildHeadWrapper } from "../../common/src/pattern/head";

/*🤫
🤫
🤫*/
export const carousel = buildHeadWrapper<CarouselPattern>(patternName, ACCEPT, PROVIDE);
